import React from 'react'
import Modal from '../Modal'
import liff from '../../util/liffHelper'

class CardDisplayNewMember extends React.Component {
  renderAction() {
    return(
      <React.Fragment>
        <button onClick={() => liff.closeWindow()} className="ui teal button">關閉視窗</button>
      </React.Fragment>
    )
  }

  renderContent() {
    return(
      <React.Fragment>
        <div className="ui list">
          <div className="item">再給我們一點作業時間，24小時後重新開啟線上社員卡即可使用！</div>
          <div className="item">如果您有任何疑問，請與我們聯絡：</div>
          <div className="item">
            <i className="phone icon"></i>
            <div className="content">
              聯絡電話│
            <a href="tel:+886-2-29996122">02-2999-6122</a>
              (專人服務時間週一至週五9:00-17:00)
          </div>
          </div>
          <div className="item">
            <i className="mail icon"></i>
            <div className="content">
              Email│
            <a href="mailto:gncoop@hucc-coop.tw">gncoop@hucc-coop.tw</a>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }

  render() {
    return (
      <Modal
        title='歡迎您加入！請再稍等24小時！'
        content={this.renderContent()}
        actions={this.renderAction()}
      />
    )
  }
}

export default CardDisplayNewMember
